<div class="i18n-demo">
  <h1>i18n Demo</h1>

  <h2>Plurals</h2>
  <p>
    {{ 'message' | i18next: { ns: 'i18n-demo', count: 1 } }}
  </p>
  <p>
    {{ 'message' | i18next: { ns: 'i18n-demo', count: 2 } }}
  </p>
  <p>
    {{ 'messageWithCount' | i18next: { ns: 'i18n-demo', count: 1 } }}
  </p>
  <p>
    {{ 'messageWithCount' | i18next: { ns: 'i18n-demo', count: 2 } }}
  </p>

  <hr />

  <h2>Context</h2>
  <p>{{ 'friend' | i18next: { ns: 'i18n-demo', context: 'male' } }}</p>
  <p>{{ 'friend' | i18next: { ns: 'i18n-demo', context: 'female' } }}</p>

  <hr />

  <h2>Context and Plurals</h2>
  <p>{{ 'friend' | i18next: { ns: 'i18n-demo', context: 'male', count: 1 } }}</p>
  <p>{{ 'friend' | i18next: { ns: 'i18n-demo', context: 'female', count: 1 } }}</p>
  <p>{{ 'friend' | i18next: { ns: 'i18n-demo', context: 'male', count: 2 } }}</p>
  <p>{{ 'friend' | i18next: { ns: 'i18n-demo', context: 'female', count: 2 } }}</p>
</div>
